export const API_URL = "https://port-0-hotel-server-6g2llf6hzu58.sel3.cloudtype.app" 